import React from 'react';

export const STATUS_LABELS = {
  draft: 'Draft',
  in_review: 'In Review',
  reviewed: 'Reviewed',
  published: 'Published',
  archived: 'Archived',
};

export default function StatusBadge({ status, className = '' }) {
  const key = (status || 'draft').toLowerCase();
  const label = STATUS_LABELS[key] || status;
  return (
    <span
      className={`status-badge status-${key} ${className}`}
      data-testid="status-badge"
    >
      {label}
    </span>
  );
}
